export default __webpack_public_path__ + "static/media/finance.2b0d4611.svg";